import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import msalConfig from './msalInstance';
import './index.css';
import { FACADE, NOM_DU_PRODUIT } from './facade/resolveFacade';
import { appliquerIdentite } from './facade/identiteDeLaPage';

// Import des styles du texteditor (migré localement)
import './lib/texteditor/styles/styles.css';

// Sur un hôte d'Azaria, le téléphone doit installer Azaria, pas Anagogia (manifeste, icône, titre).
appliquerIdentite(document, FACADE.facade, NOM_DU_PRODUIT);

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
    </React.StrictMode>
);
